import React from "react";

import "./style.css";

export const Manual = () => {
  return (
    <>
      <h3 className="manual-title">Руководство пользователя</h3>
      <div className="manual-block">
        В разделе <span className="manual-section">Мой профиль</span>{" "}
        отображается актуальная информация студента: код специальности, название
        специальности, и группа учащегося. В другом блоке отображаются
        уведомления, приходящие от преподавателей
      </div>
      <div className="manual-block">
        В разделе <span className="manual-section">Расписание</span>{" "}
        отображается актуальное расписанние на семестр и сессию. По умолчанию
        выводится расписание на семестр, ближе к сессии будет доступно для
        просмотра расписание сессии (зачёты и экзамены). Есть поле для выбора
        дня недели, в этом же поле можно выбрать опцию для просмотра расписания
        на всю неделю (Все дни). Меняя опции в полях (Выберите день недели,
        Числитель/Знаменатель) можно посмотреть расписание на интересующую
        неделю. По умолчанию будет выводится актуальное расписание, с нужным
        помером и именем недели. При клике на фамилию преподавателя есть
        возможность посмотреть его расписание. Типы занятий обозначаются
        следующим образом: Практические работы - жёлтый цвет, Лабораторные
        работы - красный цвет, Лекции - зелёный цвет.
      </div>
      {/* <div className="manual-block">
        В разделе <span className="manual-section">Статистика</span>{" "}
        отображается актуальная информация по оценкам. В первой таблице
        Выводится название предмета и срядняя оценка за этот предмет. Во второй
        таблице выводитятся все оценки по предметам, подробно по каждому с
        датами.
      </div> */}
      {/* <div className="manual-block">
        В разделе <span className="manual-section">Посещение занятий</span>{" "}
        отображается таблица, по которой видно, на каком занятии присутствовал
        студент(тип занятия), какая была тема занятия. А также какой
        преподаватель вёл данное занятие и какого числа.
      </div> */}
      <div className="manual-block">
        В разделе{" "}
        <span className="manual-section">Электронная зачетная книжка</span>{" "}
        отображается таблица, в которой видно, форму контроля, дисциплину,
        отметку, колличество часов, колличество зачетных едениц. А так же какой
        преподаватель принимал форму контроля и какого числа.
      </div>
      <div className="manual-block">
        В разделе <span className="manual-section">Пропуски занятий</span>{" "}
        отображаются карточки с задолженностями, если такие имеются. Есть два
        поля для выбора параметров, которые позволяют фильтровать по месяцу и
        году. Если есть пропуски без причины, то над карточками будет выведено
        поле, где будет указано количество таких пропусков.
      </div>
    </>
  );
};
